import script from "./ViewDeductionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDeductionsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewDeductionsPage.vue?vue&type=style&index=0&id=5ac1e5b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac1e5b2"]])

export default __exports__